var map = {
	"../catalogo/catalogo.module": [
		"./src/app/catalogo/catalogo.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"catalogo-catalogo-module"
	],
	"../compras/compras.module": [
		"./src/app/compras/compras.module.ts",
		"common",
		"compras-compras-module"
	],
	"../consignacion/consignacion.module": [
		"./src/app/consignacion/consignacion.module.ts",
		"common",
		"consignacion-consignacion-module"
	],
	"../cuentas/cuentas.module": [
		"./src/app/cuentas/cuentas.module.ts",
		"common",
		"cuentas-cuentas-module"
	],
	"../dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"../detalle-compras/detalle-compras.module": [
		"./src/app/detalle-compras/detalle-compras.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"detalle-compras-detalle-compras-module"
	],
	"../pagos/pagos.module": [
		"./src/app/pagos/pagos.module.ts",
		"common",
		"pagos-pagos-module"
	],
	"../pedidos/pedidos.module": [
		"./src/app/pedidos/pedidos.module.ts",
		"common",
		"pedidos-pedidos-module"
	],
	"../tab-cuenta/tab-cuenta.module": [
		"./src/app/tab-cuenta/tab-cuenta.module.ts",
		"common",
		"tab-cuenta-tab-cuenta-module"
	],
	"../tab-pedidos/tab-pedidos.module": [
		"./src/app/tab-pedidos/tab-pedidos.module.ts",
		"common",
		"tab-pedidos-tab-pedidos-module"
	],
	"../ventas/ventas.module": [
		"./src/app/ventas/ventas.module.ts",
		"common",
		"ventas-ventas-module"
	],
	"./auth-login/auth-login.module": [
		"./src/app/auth-login/auth-login.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"auth-login-auth-login-module"
	],
	"./cliente/cliente.module": [
		"./src/app/cliente/cliente.module.ts",
		"default~cliente-cliente-module~modal-image-modal-image-module",
		"common",
		"cliente-cliente-module"
	],
	"./detalle-pago/detalle-pago.module": [
		"./src/app/detalle-pago/detalle-pago.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"detalle-pago-detalle-pago-module"
	],
	"./detalle-venta/detalle-venta.module": [
		"./src/app/detalle-venta/detalle-venta.module.ts",
		"common",
		"detalle-venta-detalle-venta-module"
	],
	"./edita-pedido/edita-pedido.module": [
		"./src/app/edita-pedido/edita-pedido.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"edita-pedido-edita-pedido-module"
	],
	"./edita-venta/edita-venta.module": [
		"./src/app/edita-venta/edita-venta.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"common",
		"edita-venta-edita-venta-module"
	],
	"./menu/menu.module": [
		"./src/app/menu/menu.module.ts",
		"menu-menu-module"
	],
	"./personal/personal.module": [
		"./src/app/personal/personal.module.ts",
		"personal-personal-module"
	],
	"./producto/producto.module": [
		"./src/app/producto/producto.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"producto-producto-module"
	],
	"./proveedor/proveedor.module": [
		"./src/app/proveedor/proveedor.module.ts",
		"default~auth-login-auth-login-module~cart-list-cart-list-module~catalogo-catalogo-module~detalle-com~11c4209d",
		"proveedor-proveedor-module"
	],
	"./usuario/usuario.module": [
		"./src/app/usuario/usuario.module.ts",
		"common",
		"usuario-usuario-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;